export const HoverEventType = {
  //GLOBAL
  CHECK_OUT_PLANS_IN_MY_MEMBERSHIP: "Hover CHECK OUT PLANS in my membership",

  // Video note
  AI_SLIDDY_BUTTON: "Hover AI Sliddy Button",
  HELP_MENU: "Hover Help Menu",
};
